import { addDays } from 'date-fns';
import { IsBefore } from 'utils';

const dateIsValid = (inDate: string, maxDateAge: number) => {
  // Norwegian dates have DD.MM.YYYY format we want YYYY-MM-DD format
  const inDateArr = inDate.split('.');
  const inDateStr = `${inDateArr[2]}-${inDateArr[1]}-${inDateArr[0]}`;

  return IsBefore(new Date(), addDays(new Date(inDateStr), maxDateAge));
};

export { dateIsValid };
